module.exports = __webpack_public_path__ + "img/packetgrup-presentation.637f5c14.png";